module.exports = __webpack_public_path__ + "img/filter-dark.svg?1b4a229f22483edf32137bd8a19fea94";